// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login .el-input{width:280px}.login .el-form-item__label{width:85px!important}.login .el-form-item__content{margin-left:0!important}", ""]);
// Exports
module.exports = exports;
